module.exports = __webpack_public_path__ + "68160a8c7545790ed518bd87a15089d6.svg";